import { getApplications, getOpportunity } from '../services/api';
import { isNotFoundError } from './errorUtils';

// The API's page-size ceiling (pagination_limit_max), so a search's
// applications are almost always read in one request.
const PAGE_SIZE = 1000;

/**
 * The id of the application an opportunity became, or null when it has none
 * (or the opportunity no longer exists). Any other failure is thrown: an
 * unavailable server is not an answer, and the caller must not report it as
 * "not found".
 *
 * A deep link to an opportunity can outlive its pending state: a notification
 * about its contact (D19) is published while it is pending, and auto-apply or
 * the user may send it before the link is followed. The pending locator then
 * has no page for it. There is no lookup by opportunity id, so this reads the
 * opportunity for its search and finds it among that search's applications.
 */
export async function findApplicationIdForOpportunity(
  opportunityId: string
): Promise<string | null> {
  let searchId: string;
  try {
    searchId = (await getOpportunity(opportunityId)).searchId;
  } catch (error) {
    if (isNotFoundError(error)) return null;
    throw error;
  }
  for (let skip = 0; ; skip += PAGE_SIZE) {
    const page = await getApplications({ searchId, skip, limit: PAGE_SIZE });
    const match = page.applications.find(a => a.opportunityId === opportunityId);
    if (match) return match.id;
    if (page.applications.length === 0 || skip + page.applications.length >= page.total) {
      return null;
    }
  }
}
